export enum PhoneType {
  None = 1,
  CallFromHost = 2,
  CallFromGuest = 3,
}
